import { Link } from '@playbooks/ui/components/link';

export const HeaderElement = ({ size, ...props }) => {
	// Render
	switch (size) {
		case 'h1':
		case 'h2':
		case 'h3':
		case 'h4':
			return (
				<span id={props.id} className='group cursor-pointer inline-block'>
					<Link variant='link' href={'#' + props.id}>
						<span>{props.children}</span>
						<span className='text-foreground-body/60 hidden group-hover:inline-block'>#</span>
					</Link>
				</span>
			);
		default:
			return <span className='group inline-block'>{props.children}</span>;
	}
};
// Docs
